// Mock data for Ditris e-commerce

export const products = [
  {
    id: 'p1',
    name: 'Lau Plaid Shirt Jacket',
    price: 175,
    category: 'outerwear',
    sizes: ['S', 'M', 'L', 'XL'],
    colors: ['Blue', 'Green'],
    images: [
      'https://images.unsplash.com/photo-1523398002811-999ca8dec234?w=800',
      'https://images.unsplash.com/photo-1523398002811-999ca8dec234?w=800'
    ],
    description: 'Classic plaid shirt jacket with button closure. Perfect for layering in any season.',
    inStock: true,
    featured: true
  },
  {
    id: 'p2',
    name: 'Lined Denim Trucker',
    price: 195,
    category: 'outerwear',
    sizes: ['S', 'M', 'L', 'XL'],
    colors: ['Black', 'Blue'],
    images: [
      'https://images.unsplash.com/photo-1631887273317-275cd7f1129c?w=800',
      'https://images.unsplash.com/photo-1631887273317-275cd7f1129c?w=800'
    ],
    description: 'Premium denim trucker jacket with comfortable lining. A timeless wardrobe staple.',
    inStock: true,
    featured: true
  },
  {
    id: 'p3',
    name: 'Textured Zip Hooded Sweater',
    price: 185,
    category: 'sweats',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: ['Yellow', 'Cream', 'Black'],
    images: [
      'https://images.unsplash.com/photo-1508216310976-c518daae0cdc?w=800',
      'https://images.unsplash.com/photo-1508216310976-c518daae0cdc?w=800'
    ],
    description: 'Cozy textured zip-up hoodie. Perfect comfort for everyday wear.',
    inStock: true,
    featured: true
  },
  {
    id: 'p4',
    name: 'Graphic Print Tee',
    price: 45,
    category: 'tees',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: ['Black', 'White', 'Grey'],
    images: [
      'https://images.unsplash.com/photo-1538329972958-465d6d2144ed?w=800',
      'https://images.unsplash.com/photo-1538329972958-465d6d2144ed?w=800'
    ],
    description: 'Classic graphic tee with premium cotton construction.',
    inStock: true,
    featured: false
  },
  {
    id: 'p5',
    name: 'Relaxed Fit Denim',
    price: 128,
    category: 'denim',
    sizes: ['28', '30', '32', '34', '36'],
    colors: ['Blue', 'Black'],
    images: [
      'https://images.unsplash.com/photo-1588117260148-b47818741c74?w=800',
      'https://images.unsplash.com/photo-1588117260148-b47818741c74?w=800'
    ],
    description: 'Premium relaxed fit denim jeans. Comfort meets style.',
    inStock: true,
    featured: false
  },
  {
    id: 'p6',
    name: 'Classic Pullover Hoodie',
    price: 98,
    category: 'sweats',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: ['Black', 'Grey', 'Navy'],
    images: [
      'https://images.pexels.com/photos/35349438/pexels-photo-35349438.jpeg?w=800',
      'https://images.pexels.com/photos/35349438/pexels-photo-35349438.jpeg?w=800'
    ],
    description: 'Essential pullover hoodie with kangaroo pocket.',
    inStock: true,
    featured: false
  },
  {
    id: 'p7',
    name: 'Work Shirt',
    price: 88,
    category: 'tops',
    sizes: ['S', 'M', 'L', 'XL'],
    colors: ['Khaki', 'Black', 'Blue'],
    images: [
      'https://images.pexels.com/photos/35378716/pexels-photo-35378716.jpeg?w=800',
      'https://images.pexels.com/photos/35378716/pexels-photo-35378716.jpeg?w=800'
    ],
    description: 'Durable work shirt with button-down collar.',
    inStock: true,
    featured: false
  },
  {
    id: 'p8',
    name: 'Cargo Pants',
    price: 108,
    category: 'pants',
    sizes: ['28', '30', '32', '34', '36'],
    colors: ['Khaki', 'Black', 'Olive'],
    images: [
      'https://images.pexels.com/photos/35550303/pexels-photo-35550303.jpeg?w=800',
      'https://images.pexels.com/photos/35550303/pexels-photo-35550303.jpeg?w=800'
    ],
    description: 'Functional cargo pants with multiple pockets.',
    inStock: true,
    featured: false
  },
  {
    id: 'p9',
    name: 'Striped Long Sleeve',
    price: 68,
    category: 'tops',
    sizes: ['S', 'M', 'L', 'XL'],
    colors: ['Navy/White', 'Black/White'],
    images: [
      'https://images.unsplash.com/photo-1538329972958-465d6d2144ed?w=800',
      'https://images.unsplash.com/photo-1538329972958-465d6d2144ed?w=800'
    ],
    description: 'Classic striped long sleeve tee.',
    inStock: false,
    featured: false
  },
  {
    id: 'p10',
    name: 'Baseball Cap',
    price: 38,
    category: 'headwear',
    sizes: ['One Size'],
    colors: ['Black', 'Navy', 'Khaki'],
    images: [
      'https://images.unsplash.com/photo-1588117260148-b47818741c74?w=800',
      'https://images.unsplash.com/photo-1588117260148-b47818741c74?w=800'
    ],
    description: 'Classic six-panel baseball cap with adjustable strap.',
    inStock: true,
    featured: false
  },
  {
    id: 'p11',
    name: 'Beanie',
    price: 32,
    category: 'headwear',
    sizes: ['One Size'],
    colors: ['Black', 'Grey', 'Navy', 'Burgundy'],
    images: [
      'https://images.unsplash.com/photo-1523398002811-999ca8dec234?w=800',
      'https://images.unsplash.com/photo-1523398002811-999ca8dec234?w=800'
    ],
    description: 'Warm knit beanie for cold weather.',
    inStock: true,
    featured: false
  },
  {
    id: 'p12',
    name: 'Sunglasses',
    price: 78,
    category: 'accessories',
    sizes: ['One Size'],
    colors: ['Black', 'Tortoise'],
    images: [
      'https://images.unsplash.com/photo-1508216310976-c518daae0cdc?w=800',
      'https://images.unsplash.com/photo-1508216310976-c518daae0cdc?w=800'
    ],
    description: 'Classic frame sunglasses with UV protection.',
    inStock: true,
    featured: false
  }
];

export const categories = [
  { id: 'new-arrivals', name: 'NEW ARRIVALS', slug: 'new-arrivals' },
  { id: 'tees', name: 'TEES', slug: 'tees' },
  { id: 'outerwear', name: 'OUTERWEAR', slug: 'outerwear' },
  { id: 'sweats', name: 'SWEATS', slug: 'sweats' },
  { id: 'denim', name: 'DENIM', slug: 'denim' },
  { id: 'tops', name: 'TOPS & SHIRTS', slug: 'tops' },
  { id: 'knits', name: 'KNITS', slug: 'knits' },
  { id: 'pants', name: 'PANTS', slug: 'pants' },
  { id: 'shorts', name: 'SHORTS', slug: 'shorts' },
  { id: 'headwear', name: 'HEADWEAR', slug: 'headwear' },
  { id: 'sunglasses', name: 'SUNGLASSES', slug: 'sunglasses' },
  { id: 'accessories', name: 'ACCESSORIES', slug: 'accessories' }
];

export const heroImages = [
  {
    id: 'h1',
    image: 'https://images.unsplash.com/photo-1523398002811-999ca8dec234?w=1600',
    title: 'Spring 2025 Collection',
    link: '/shop/new-arrivals'
  },
  {
    id: 'h2',
    image: 'https://images.unsplash.com/photo-1631887273317-275cd7f1129c?w=1600',
    title: 'New Arrivals',
    link: '/shop/new-arrivals'
  }
];